export default {
  inserted(el) {
    const inputs = el.querySelectorAll('input');

    inputs.forEach(input => {
      if (input.hasAttribute('placeholder')) {
        const cache = input.getAttribute('placeholder');
        input.addEventListener('focus', () => input.setAttribute('placeholder', ''));
        input.addEventListener('blur', () => input.setAttribute('placeholder', cache));
      }
    });
  },
};
